import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";

import { ChallengeService } from "@services";
import {
  getActiveChallenges,
  getActiveChallengesError,
  getActiveChallengesSuccess,
  getChallenges,
  getChallengesError,
  getChallengesSuccess,
} from "./challenges.actions";

@Injectable()
export class ChallengesEffects {
  public readonly getChallenges$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getChallenges),
      mergeMap(() =>
        this._challengeService.getUserChallenges().pipe(
          map((response) => getChallengesSuccess({ challenges: response.data })),
          catchError((error) => of(getChallengesError({ error }))),
        ),
      ),
    ),
  );

  public readonly getActiveChallenges$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getActiveChallenges),
      mergeMap(() =>
        this._challengeService.getUserActiveChallenges().pipe(
          map((response) => getActiveChallengesSuccess({ challenges: response })),
          catchError((error) => of(getActiveChallengesError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _challengeService: ChallengeService,
  ) {}
}
